import { useState, useEffect } from "react";
import { getCurrentUser } from "../../../utils/authSession";
import { adminDashboardService } from "../services/adminDashboardService";
export const useAdminProfile = () => {
  const [userData, setUserData] = useState(null);
  const [userId, setUserId] = useState(null);
  const [profileImageUrl, setProfileImageUrl] = useState("");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  useEffect(() => {
    const fetchProfile = async () => {
      try {
        const { userId } = await getCurrentUser();
        setUserId(userId);
        
        const data = await adminDashboardService.getAdminProfile();
        setUserData(data);
        
        setProfileImageUrl(
          data.profile
            ? `${process.env.REACT_APP_PROFILE_PHOTOS_HOST}/OrganizationAdmins/${userId}_${data.profile}`
            : "/profileheaderhover.png"
        );
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };
    fetchProfile();
  }, []);
  return { userData, userId, profileImageUrl, loading, error };
};
